<template>
  <div />
</template>

<script>
export default {
  name: 'AiSettings'
}
</script>
